import FAQList from './FAQList/FAQList';
import SectionHeader from '../TextElements/SectionHeader/SectionHeader';

const FAQs = props => {

	const questions = [
		{
			id: 0,
			question: 'What makes your olive oil so good?',
			answer: `A number of unique factors coming together make our olive oil truly spectacular. 
			Our olive oil is produced on a single estate, in a region known for its high quality olive oil. 
			Our grove has olive trees with ages ranging from a few decades old to over a thousand years old.
			The soil and the trees have been enriched by fires. Our family has been working with world 
			renowned consultants from Italy to ensure the highest quality farming and production practices. As a result the olive oil produced by our grove  has 
			been awarded gold medals in international olive oil competitions on both sides of the Atlantic.`,
			showOnRestaurantsPage: true
		}, 
		{
			id: 1,
			question: 'Which olive oil is right for me?',
			answer: `We have two different bottles: Luxe, and Private Reserve. 
			If you are looking for a spectacular olive oil for any use, cooking, frying, dressing or dipping, you can’t go wrong with Luxe. 
			Luxe has a pungent taste and rich aromas. It has been a favorite in international tasting competitions, winning a gold-medal 
			in the 2025 New York International Olive Oil Competition. Thanks to its high smoke point of 405°F you can fry with it up to 6 times without losing any of the health benefits. 
			If you want to treat yourself to a finer olive oil to dress, dip, or finish your salads, soups, hummus, even ice creams and coffee, 
			you can't go wrong with Private Reserve. Private Reserve has a smooth, rich taste. It consistently comes in as one of the best
			olive oils in the world in tasting competitions, winning yet another gold-medal in the 2025 New York International Olive Oil 
			Competition. Still unsure? Order a Tasting Collection and we'll send you a bottle of each for you to try.`,
			showOnRestaurantsPage: true
		}, 
		{
			id: 2,
			question: 'How does shipping work?',
			answer: `We offer free shipping for all our membership options. It is also worth noting that 
			we currently only ship to the US.`,
			showOnRestaurantsPage: true
		},
		{
			id: 3,
			question: 'What is your refund policy?',
			answer: `We want you to be happy with our olive oil. If you try our olive oil and don’t like it, 
			we’ll ask you to return the olive oil so we can figure out what went wrong (shipping on us) and 
			issue you a refund.`,
			showOnRestaurantsPage: true
		},
		{
			id: 4,
			question: 'Why do you encourage customers to become members?',
			answer: `Our olive oil is produced on our family estate in the Dardanelles. As a single estate 
			producer, quantities are limited to what our grove can produce. To ensure those who truly 
			appreciate our olive oil can always have access, we control how many members we have and 
			make sure we have enough olive oil to supply them. There are other benefits to becoming a 
			member as well (like better pricing, free bottles …etc), but the main benefit is that we’ll 
			always have enough supply in-hand for you. `,
			showOnRestaurantsPage: false
		}
	]

	const pathname= window.location.pathname;
	
	let filteredQuestions = [...questions];
	if (pathname === '/restaurants') {
		filteredQuestions = questions.filter(question=>question.showOnRestaurantsPage)
	}

	return(
		<div className='col-lg-9 py-5 mb-2'>
			<SectionHeader><em>Frequently asked questions</em></SectionHeader>
			<FAQList questions={filteredQuestions}/>
		</div>
	)

}

export default FAQs